export const rightPannelContextEn = {
  toAllChats: 'Go to all chats',
  noMsg: 'No messages in this chat yet. Start conversation'
}

export const rightPannelContextRu: typeof rightPannelContextEn = {
  toAllChats: 'К списку всех чатов',
  noMsg: 'Здесь пока пусто. Напишите сообщение в чат'
}

export const rightPannelCrmContextEn: typeof rightPannelContextEn = {
  toAllChats: 'Deals and chats',
  noMsg: 'Here you can chat with other YouGile users'
}

export const rightPannelCrmContextRu: typeof rightPannelContextEn = {
  toAllChats: 'Сделки и чаты',
  noMsg: 'Здесь вы можете общаться с другими пользователями YouGile'
}
